export { default as IndexTableCell } from './IndexTableCell';
